// extracted by mini-css-extract-plugin
export default {"component":"SvgIcon_component__JACFB","fullSize":"SvgIcon_fullSize__51pqN","halfSize":"SvgIcon_halfSize__u-SCt","smallSize":"SvgIcon_smallSize__gGQhd"};